(function ($) {
    $('input[name="Beginn der Änderung"]').datepicker({
        dateFormat: 'dd.mm.yy', minDate: 0,
        beforeShow: function() {
            setTimeout(function(){
                $('.ui-datepicker').css('z-index', 99999999999999);
            }, 0);
        }
    });
    $('input[name="Ende der Änderung"]').datepicker({
        dateFormat: 'dd.mm.yy', minDate: 0,
        beforeShow: function() {
            setTimeout(function(){
                $('.ui-datepicker').css('z-index', 99999999999999);
            }, 0);
        }
    });
})(jQuery);

(function ($) {
    $('input[name=Kundennummer_unbekannt]').change(function() {
        if($(this).prop('checked')){
            $(this).parents('form').find('input[name=Kundennummer]').removeAttr('required');
        } else {
            $(this).parents('form').find('input[name=Kundennummer]').attr('required', '');
        }
    })
})(jQuery);

// Show location selectbox if 'social' is selecteded from the 'Lieferunterbrechung' selectbox
$(function () {
    var $locations = $('.container-selectbox--service-locations');
    $locations.hide();
    $('.container-selectbox--service-type').find('select').change(function () {
        var currentValue = this.value;
        currentValue === 'Soziale Einrichtung' ?  $locations.show() : $locations.hide();
    });
});

// Show address box only if 'Nachsenden' is selected from the 'Lieferunterbrechung' selectbox
$(function () {
    var $addressBox = $('.urlaubsservice-address-box'),
        $addressContact = $addressBox.find('.formular-kontaktdaten');

    $addressBox.hide();
    $('.container-selectbox--service-type').find('select').change(function () {
        var currentValue = this.value;
        if(currentValue === 'Nachsenden') {
            $addressBox.show()
            $addressContact.find('[data-required=true]').each(function(i, el) {
                $(el).attr('required', '');
            })
        } else {
            console.log('test');
            $addressBox.hide();
            $addressContact.find('[data-required=true]').each(function(i, el) {
                $(el).removeAttr('required');
            })
        }  
    });
});